import { createFileRoute, getRouteApi, useRouter } from '@tanstack/react-router'

import { GridItem } from '@masterplandev/ui'

import { ContainerFullViewport } from '@/core/components/ui/ContainerFullViewport/ContainerFullViewport'
import { URL_DISCOVER_CHANNELS } from '@/core/constants/constants'
import { FEATURE_DISCOVER_ADVANCED_FILTERS } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { toDiscoverChannelsLinkSearch } from '@/discover/utils/advancedFiltersSearch'
import { TopicSection } from '@/topic/components/TopicSection/TopicSection'

const discoverChannelsRoute = getRouteApi('/_learning/discover/channels')

export const Route = createFileRoute(
  '/_learning/discover/channels/_overview/view/$channel/$topic',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { topic } = Route.useParams()
  const hasAdvancedFiltersFeature = useFeatures(
    FEATURE_DISCOVER_ADVANCED_FILTERS,
  )
  const channelsSearch = discoverChannelsRoute.useSearch()
  const router = useRouter()
  const returnUrl = hasAdvancedFiltersFeature
    ? router.buildLocation({
        to: '/discover/channels',
        search: toDiscoverChannelsLinkSearch(channelsSearch),
      }).href
    : URL_DISCOVER_CHANNELS

  return (
    <GridItem gridColumn="1 / -1">
      <ContainerFullViewport left="50%" transform="translateX(-50%)">
        <TopicSection
          lectureContext="channel"
          returnUrl={returnUrl}
          topicSlug={topic}
        />
      </ContainerFullViewport>
    </GridItem>
  )
}
